import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { useGenerators } from "../../../../../hooks/useGenerators";
import { useMastrData } from "../../../../../hooks/useMastrData";

interface GetMaStRColumnProps {
  generatorId?: number;
  siteId?: number;
  siteIdKey?: string;
  generatorIdKey?: string;
}

export function getMaStRColumn<T extends MRT_RowData>({
  siteId = undefined,
  generatorId = undefined,
  siteIdKey = "site_id",
  generatorIdKey = "generator_id"
}: GetMaStRColumnProps = {}): MRT_ColumnDef<T> {
  return {
    header: "MaStR-Nummer",
    enableEditing: false,
    enableSorting: true,
    enableGlobalFilter: false,
    Cell: ({ row }) => (
      <SmartMaStRNumberCell
        generatorId={generatorId || row.original[generatorIdKey]}
        siteId={siteId || row.original[siteIdKey]}
      />
    )
  };
}

function SmartMaStRNumberCell({
  siteId,
  generatorId
}: {
  siteId: number;
  generatorId: number;
}) {
  const { data: generators, error } = useGenerators({ siteId });

  const endpoint = generators?.find(
    (generator) => generator.id === generatorId
  )?.einheit;

  if (error) return <>{error.message}</>;
  return <MaStRNumberCell endpoint={endpoint} />;
}

function MaStRNumberCell({ endpoint }: { endpoint?: string | null }) {
  const { data, isLoading } = useMastrData(endpoint);

  if (!endpoint) {
    return null;
  }

  return isLoading
    ? "Wird geladen..."
    : (data?.einheitMastrNummer ?? "Keine Daten");
}
